import { render } from "./MultipleBarcodes.vue?vue&type=template&id=079542ae"
import script from "./MultipleBarcodes.vue?vue&type=script&lang=js"
export * from "./MultipleBarcodes.vue?vue&type=script&lang=js"

import "./MultipleBarcodes.vue?vue&type=style&index=0&id=079542ae&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/MultipleBarcodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "079542ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('079542ae', __exports__)) {
    console.log('reload')
    api.reload('079542ae', __exports__)
  }
  
  module.hot.accept("./MultipleBarcodes.vue?vue&type=template&id=079542ae", () => {
    console.log('re-render')
    api.rerender('079542ae', render)
  })

}


export default __exports__